import { createRouter, createWebHashHistory } from "vue-router";
import UserLogin from "../views/user/Login.vue";
import App from "../views/app/Index.vue";
import AnalyseCompleteActeurs from "../views/app/modules/AnalyseCompleteActeurs.vue";
import AnalyseRisques from "../views/app/modules/AnalyseRisques.vue";
import FormulationVision from "../views/app/modules/FormulationVision.vue";
import MatricePriorisation from "../views/app/modules/MatricePriorisation.vue";
import ModeleResultat from "../views/app/modules/ModeleResultat.vue";
import PageParticipant from "../views/app/PageParticipant.vue";
import PageDescription from "../views/app/PageDescription.vue";
import Tools from "../views/app/Tools.vue";
import Folders from "../views/app/Folders.vue";
import Files from "../views/app/Files.vue";
import NotFound from "../views/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "App",
    component: App,
    redirect: "/app/tools",
    beforeEnter: (to, from, next) => {
      if (
        localStorage.getItem("stratochange.user") != null &&
        localStorage.getItem("stratochange.user").length > 0
      ) {
        next();
      } else {
        localStorage.removeItem("stratochange.user");
        next({ name: "user/login" });
      }
    },

    children: [
      {
        path: "app/folders",
        component: Folders,
        meta: {
          title: "Folders"
        }
      },
      {
        path: "app/files",
        component: Files,
        meta: {
          title: "Files"
        }
      },
      {
        path: "app/participants",
        component: PageParticipant,
        meta: {
          title: "Participant du projets"
        }
      },
      {
        path: "app/description",
        component: PageDescription,
        meta: {
          title: "Description du module"
        }
      },
      {
        path: "app/analyse-complete-acteurs",
        component: AnalyseCompleteActeurs,
        meta: {
          title: "Analyse complète des Acteurs"
        }
      },
      {
        path: "app/analyse-risques",
        component: AnalyseRisques,
        meta: {
          title: "Analyse des Risques"
        }
      },
      {
        path: "app/formulation-vision",
        component: FormulationVision,
        meta: {
          title: "Formulation de la Vision"
        }
      },
      {
        path: "app/matrice-priorisation",
        component: MatricePriorisation,
        meta: {
          title: "Matrice de Priorisation"
        }
      },
      {
        path: "app/modele-resultats",
        component: ModeleResultat,
        meta: {
          title: "Modele de Résultat"
        }
      },
      {
        path: "app/tools",
        component: Tools,
        meta: {
          title: "Tools"
        }
      }
    ]
  },
  {
    name: "NotFound",
    path: "/:pathMatch(.*)",
    component: NotFound,
    meta: {
      title: "404 Not Found"
    }
  },
  {
    path: "/login",
    name: "user/login",
    component: UserLogin
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.afterEach(to => {
  document.title = to.meta.title;
});

export default router;
